<template>
  <button
    :class="styles + 'transform transition-transform duration-300 ease-out-cubic'"
    @click="handleClick"
    :aria-label="buttonLabel"
    :aria-expanded="isOpen.valueOf() ? 'true' : 'false'" 
    role="button"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3431 5.3431L8.00981 10.6764L2.67647 5.3431"
        stroke="#612141"
        stroke-width="3"
      />
    </svg>
  </button>
</template>

<script lang="ts" setup>
import { ref, toRefs, computed } from "vue";
const props = withDefaults(defineProps<{ isOpen: boolean }>(), {
  isOpen: false,
});

const { isOpen } = toRefs(props);

const styles = computed(() => {
  return isOpen.value ? "rotate-180 " : "rotate-0";
});

const buttonLabel = computed(() => {
  return isOpen.value ? 'Collapse content' : 'Expand content';
});

type Emits = {
  (e: "handleClick"): void;
};
const emit = defineEmits<Emits>();

const handleClick = () => {
  emit("handleClick");
};
</script>
